// Deterministic hue derivation for informational-event cover placeholders.
// Given a stable id, returns an integer hue in [0, 360) so the same event
// always renders the same accent color across SSR and client (no flicker) and
// distinct events spread reasonably around the wheel.
//
// No Vue/Nuxt imports — auto-imported by Nuxt from `app/utils/`.
// Deterministic by construction: no Math.random, no Date.

/**
 * Map an id to a stable hue in the range [0, 360).
 *
 * Uses a djb2 string hash over the id's char codes, then folds the 32-bit
 * result into the hue range. Same id → same hue; different ids are spread
 * across the wheel.
 */
export function hueFromId(id: string): number {
  // djb2: hash = hash * 33 + c, seeded at 5381.
  let hash = 5381;
  for (let i = 0; i < id.length; i++) {
    // `| 0` keeps the running value a 32-bit integer to avoid precision drift.
    hash = ((hash << 5) + hash + id.charCodeAt(i)) | 0;
  }
  // Force unsigned before modulo so negative hashes still map into [0, 360).
  return (hash >>> 0) % 360;
}
